module.exports = __webpack_public_path__ + "img/gagaga.158a55c5.png";